import styled from 'styled-components'
import { Fonts } from 'components/base-ui'
import colors from 'styles/colors'

const DetailItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const TitleRegular = styled(Fonts.BaseTitleRegular)`
  padding: 3px;
  display: flex;
  align-items: center;
  column-gap: 4px;
`

const AdjustmentTotal = styled(TitleRegular)`
  white-space: nowrap;
  align-self: flex-start;
`

const Adjustments = styled(DetailItem)`
  color: ${colors.primary};
`

export { Adjustments, TitleRegular, AdjustmentTotal, DetailItem }
